const CambodiaData = [
  {
    "Object Type": "Commercial Organization",
    Label: "Sheico (Cambodia) Co., Ltd",
    "Organization Name": "Sheico (Cambodia) Co., Ltd",
    Type: "Neoprene Wet Suits",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Kiri Sakor Koh Kong SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Khum Prek Kasach, Srock Kirisakor, Koh Kong\\nprovince",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "1,750 Ha|The ID Number (C15) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Kiri Sakor Koh Kong\\nsez|Kiri Sakor Koh Kong SEZ",
    "ID Number": "C15",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "L.Y.P Group Co., Ltd.",
    "Organization Name": "L.Y.P Group Co., Ltd.|LYP group",
    Type: "",
    "Located IVO": "",
    Source: "ABOUT KKSEZ – Koh Kong SEZ|https://kksez.com/about-us/",
    Notes: "Koh Kong SEZ industrial estate is a subsidiary of LYP group",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "ABOUT KKSEZ – Koh Kong SEZ.pdf (Document)|Neang Kok Koh Kong SEZ (Location)",
    "Link: President Of": "H.E. Oknha Ly Yong Phat (Person)",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Izumi (Cambodia) Co., Ltd.",
    "Organization Name": "Izumi (Cambodia) Co., Ltd.",
    Type: "Tv Frame And Electric Parts",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Person",
    Label: "Ly Yong Phat",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "Cambodian People's Party Senator",
    Name: "Ly Yong Phat",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "Ly Arporn (Person)",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Denso Electronics",
    "Organization Name": "Denso Electronics",
    Type: "Wiring Harness",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Goldfame Enterprises (Int'l) Knitters Limited",
    "Organization Name": "Goldfame Enterprises (Int'l) Knitters Limited",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "Chan Chi Kwong (Person)",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Sumi (Cambodia) Wiring Systems Co., Ltd.",
    "Organization Name": "Sumi (Cambodia) Wiring Systems Co., Ltd.",
    Type: "Wiring Harness",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Goldfame Pak Shun SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "The ID Number (C3) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Goldfame Pak Shun SEZ",
    "ID Number": "C3",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Kampot SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "The ID Number (C11) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Kampot SEZ",
    "ID Number": "C11",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Marunix (Cambodia) Co., Ltd.",
    "Organization Name": "Marunix (Cambodia) Co., Ltd.",
    Type: "Wire Harness Assembly",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Forest Packing (Cambodia) Co., Ltd",
    "Organization Name": "Forest Packing (Cambodia) Co., Ltd",
    Type: "Packing Bag",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Manhattan SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Bavet Commune, Chantrea District, Svay Rieng\\nprovince",
    Source:
      "Development History – Manhattan SEZ in Cambodia|https://www.manhattansez.com/%e5%95%86%e7%95%8c%e9%96%8b%e7%99%bc/",
    Notes: "157 Ha.",
    "Location Name": "Manhattan (svay Reing) SEZ|Manhattan SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "ARC Cambodia Corp. (Commercial Organization)|Ampac Packaging (Cambodia) Ltd. (Commercial Organization)|Angkor Spring Co., Ltd (Commercial Organization)|Best Way Industry Co., Ltd. (Commercial Organization)|Eastern Industrial Enterprise Inc. (Commercial Organization)|Elite (Cambodia) Co., Ltd. (Commercial Organization)|Forest Packing (Cambodia) Co., Ltd (Commercial Organization)|Galaxy Textile Co., Ltd (Commercial Organization)|Kaoway Sports Ltd. (Commercial Organization)|Kingmaker Footwear Co., Ltd (Commercial Organization)|Leegrow Plastic Packaging Co., Ltd. (Commercial Organization)|MSEZ Comfort Hospital Co., Ltd (Commercial Organization)|Morofuji (Cambodia) Co., Ltd. (Commercial Organization)|Pique Garment Co., Ltd (Commercial Organization)|S.Y.G. Steel International Co., Ltd (Commercial Organization)|Sheico (Cambodia) Co., Ltd (Commercial Organization)|Top Sports Textile Ltd. (Commercial Organization)|Visca Plastics Joint Stock Company (Commercial Organization)",
    "Link: Appears In":
      "Cambodia Development Council (CDC) (Government Organization)|Cambodia Investment Commission (CIB) (Government Organization)|Manhattan International Co.,Ltd. (Commercial Organization)|Manhattan International Corporation (MIC) (Commercial Organization)|SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Aley Global (Cambodia) co., Ltd.",
    "Organization Name": "Aley Global (Cambodia) co., Ltd.",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Poi Pet O'neang SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Poipet Commune And Nimit Commune, O' Chhrov District, Banteay Meanchey Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "467Ha|The ID Number (C24) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Poi Pet O'neang SEZ|Poi Pet O'neang SEZ",
    "ID Number": "C24",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Campack Co., Ltd. (Commercial Organization)",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Government Organization",
    Label: "Cambodia Development Council (CDC)",
    "Organization Name": "Cambodia Development Council|Cambodia Development Council (CDC)",
    Type: "",
    "Located IVO": "",
    Source:
      "Development History – Manhattan SEZ in Cambodia|https://www.manhattansez.com/%e5%95%86%e7%95%8c%e9%96%8b%e7%99%bc/",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "Development History – Manhattan SEZ in Cambodia.pdf (Document)|Manhattan SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Worldtec Cycles (Cambodia) Co., Ltd",
    "Organization Name": "Worldtec Cycles (Cambodia) Co., Ltd",
    Type: "Bicycles Asembling",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Colben Energy (Cambodia) PPSEZ Ltd.",
    "Organization Name": "Colben Energy (Cambodia) PPSEZ Ltd.",
    Type: "Power Plant",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Try Pheap Group Co., Ltd.",
    "Organization Name": "Try Pheap Group Co., Ltd|Try Pheap Group Co., Ltd.",
    Type: "",
    "Located IVO": "",
    Source: "Try Pheap Group CO.,Ltd|http://trypheapgroup.com/en/?page=10",
    Notes:
      "the Company has been developing infrastructures such as roads, water and electricity network systems, ponds, gardens, administration buildings, warehouses, etc",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Thmor Da SEZ (Location)",
    "Link: Appears In": "Try Pheap Group CO.,Ltd.pdf (Document)|Try Pheap Ou Ya Dav SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Prosource Electronics (Cambodia) Co., Ltd.",
    "Organization Name": "Prosource Electronics (Cambodia) Co., Ltd.",
    Type: "Household Appliances",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "C.I.I.D.G Erdos Hongjun Electric Power Co., Ltd",
    "Organization Name": "C.I.I.D.G Erdos Hongjun Electric Power Co., Ltd",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 1 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "MSEZ Comfort Hospital Co., Ltd",
    "Organization Name": "MSEZ Comfort Hospital Co., Ltd",
    Type: "Hospital",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Person",
    Label: "Ly Arporn",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "Ly Arporn",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "Ly Yong Phat (Person)",
    "Link: Manager of": "",
    "Link: Spouse of": "Seng Nhak (Person)",
    "Link: Director Of": "Premier Land Sihanoukville (Commercial Organization)",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Phnom Penh SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Khan Dangkao, Phnom Penh And Ang Snuol\\ndistrict, Kandal Province",
    Source:
      "Investor Relations PPSEZ|SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839|https://www.ppsez.com/en/investor-relation/business-overview?ref=ci",
    Notes:
      "350 Ha.|The ID Number (C5) is a unique ID number created for research purposes. It is not a true ID number.|over 357 hectares in size and more than 80 international companies from 15 different nations invested in the zone",
    "Location Name": "Phnom Penh SEZ|Phnom Penh SEZ",
    "ID Number": "C5",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "Agricom (Cambodia) Co., Ltd (Commercial Organization)|Ajinomoto (Cambodia) Co., Ltd. (Commercial Organization)|Atlas Ice (Cambodia) Co., Ltd. (Commercial Organization)|Bok Seng PPSEZ Dry Port Co., Ltd (Commercial Organization)|Cambodia Success Industries Co., Ltd (Commercial Organization)|Cambodian Food Processing and Distribution Co., Ltd. (Commercial Organization)|Cambox Private Limited (Commercial Organization)|Civil (CP) Construction Product Ltd (Commercial Organization)|Clean Circle Co., Ltd (Commercial Organization)|Colben Energy (Cambodia) PPSEZ Ltd. (Commercial Organization)|Combi (Cambodia) Co., Ltd (Commercial Organization)|Daiwa Onkyo (Commercial Organization)|Denso Electronics (Commercial Organization)|Dishells (Cambodia) Ltd. (Commercial Organization)|Evergreen Industrial Co., Ltd (Commercial Organization)|FST PP Co., Ltd. (Commercial Organization)|Haru Phnom Penh Comic Center Co., Ltd (Commercial Organization)|Ji-Xiang Co., Ltd (Commercial Organization)|Kyowaseikan (Cambodia) Co., Ltd. (Commercial Organization)|Liwayway (Cambodia) Food Industries Co., Ltd. (Commercial Organization)|MKK Co., Ltd (Commercial Organization)|Marunix (Cambodia) Co., Ltd. (Commercial Organization)|Minebea (Cambodia) Co., Ltd (Commercial Organization)|Navy Water Production Co., Ltd (Commercial Organization)|O and M (Cambodia) Co., Ltd. (Commercial Organization)|Proceeding (Phnom Penh) Co., Ltd (Commercial Organization)|Redial Industrial Co., Ltd (Commercial Organization)|Shin Feng Paper Co., Ltd. (Commercial Organization)|Sichuan New Hope Agribusiness (Cambodia) Co., Ltd. (Commercial Organization)|Sin Chn Hong (Cambodia) Plastics Industry Co., Ltd. (Commercial Organization)|Sumi (Cambodia) Wiring Systems Co., Ltd. (Commercial Organization)|Sunhsin Thread And String (Cambodia) Co., Ltd. (Commercial Organization)|Thibidi (Cambodia) Co., Ltd (Commercial Organization)|Tiger Wing Co., Ltd (Commercial Organization)|Yamaha Motor (Cambodia) Company Limited Co., Ltd (Commercial Organization)|Yi Xiang Co., Ltd (Commercial Organization)|Zion Label And Printing Co., Ltd. (Commercial Organization)",
    "Link: Appears In":
      "Phnom Penh SEZ Plc. (Commercial Organization)|SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Minebea (Cambodia) Co., Ltd",
    "Organization Name": "Minebea (Cambodia) Co., Ltd",
    Type: "Small-Size Motor",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Cambodia Success Industries Co., Ltd",
    "Organization Name": "Cambodia Success Industries Co., Ltd",
    Type: "Steel Processing For Construction Material",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Atlantic Cycle Co., Ltd.",
    "Organization Name": "Atlantic Cycle Co., Ltd.",
    Type: "Bicycle",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Best Way Industry Co., Ltd.",
    "Organization Name": "Best Way Industry Co., Ltd.",
    Type: "Bicycle",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Sihanoukville SEZ 1",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Stung Hav District, Preah\\nsihanouk Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "178 Ha|The ID Number (C35) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Sihanoukville SEZ 1|Sihanoukville SEZ 1",
    "ID Number": "C35",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "C.I.I.D.G Erdos Hongjun Electric Power Co., Ltd (Commercial Organization)|Cambodian Energy Limited (Commercial Organization)",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Kampong Saom SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Village 4, Ortres Commune, Stung Hav District,\\npreah Sihanouk Province",
    Source: "",
    Notes: "255 Ha",
    "Location Name": "Kampong Saom SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Goldfame Pak Shun SEZ Co., Ltd",
    "Organization Name": "Goldfame Pak Shun SEZ Co., Ltd",
    Type: "",
    "Located IVO": "",
    Source: "https://sithi.org/landissue/source/SEZ/All%20SEZ%20list.pdf",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Thmor Da SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Located In Sangkum Thmey Village, Thmor Da Commune, Veal Veng District, Pursat Province",
    Source: "",
    Notes:
      "covering approximately 2,265 hectares of land|this zone is sub-divided into two zones: Tourism, Commercial and Shopping Center Development Zone covering 594 hectares of land, and Agro-Industrial Crops Zone covering 1,671 hectares of land. ©",
    "Location Name": "Thmor Da SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Try Pheap Group Co., Ltd. (Commercial Organization)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Thibidi (Cambodia) Co., Ltd",
    "Organization Name": "Thibidi (Cambodia) Co., Ltd",
    Type: "Electrical Equipment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Smart Tech (Cambodia) Co., Ltd",
    "Organization Name": "Smart Tech (Cambodia) Co., Ltd",
    Type: "Bicycle",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Yi Xiang Co., Ltd",
    "Organization Name": "Yi Xiang Co., Ltd",
    Type: "Plastic",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Campack Co., Ltd.",
    "Organization Name": "Campack Co., Ltd.",
    Type: "Jewelry Packing Manufacturing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Poi Pet O'neang SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Manhattan International Co.,Ltd.",
    "Organization Name": "Manhattan International Co.,Ltd.",
    Type: "",
    "Located IVO": "",
    Source:
      "Development History – Manhattan SEZ in Cambodia|https://www.manhattansez.com/%e5%95%86%e7%95%8c%e9%96%8b%e7%99%bc/",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "Development History – Manhattan SEZ in Cambodia.pdf (Document)|Manhattan SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Morofuji (Cambodia) Co., Ltd.",
    "Organization Name": "Morofuji (Cambodia) Co., Ltd.",
    Type: "Bags And Package Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Poipet Pp SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes:
      "is situated only 8 km east of the Poipet city center|located with direct access to National Road No. 5",
    "Location Name": "Poipet Pp SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "Phnom Penh SEZ Plc. (Commercial Organization)",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "S.Y.G. Steel International Co., Ltd",
    "Organization Name": "S.Y.G. Steel International Co., Ltd",
    Type: "Bolt-Nut",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Helsa South East Asia Co., Ltd.",
    "Organization Name": "Helsa South East Asia Co., Ltd.",
    Type: "Shoulder Pads",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Redial Industrial Co., Ltd",
    "Organization Name": "Redial Industrial Co., Ltd",
    Type: "Plastic",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Cambodian Food Processing and Distribution Co., Ltd.",
    "Organization Name": "Cambodian Food Processing and Distribution Co., Ltd.",
    Type: "Food Processing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Yazaki Corporation",
    "Organization Name": "Yazaki Corporation",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Neang Kok Koh Kong SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Good Ray Development Limited",
    "Organization Name": "Good Ray Development Limited",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "21, Paksun (SEZ), Setbou Commune, S'ang District, Kandal\\nprovince , Cambodia.\\n (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Ampac Packaging (Cambodia) Ltd.",
    "Organization Name": "Ampac Packaging (Cambodia) Ltd.",
    Type: "Packaging Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Taihua Plastic Products Co., Ltd.",
    "Organization Name": "Taihua Plastic Products Co., Ltd.",
    Type: "Plastics",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Kingmaker Footwear Co., Ltd",
    "Organization Name": "Kingmaker Footwear Co., Ltd",
    Type: "Footwear)",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Angkor Spring Co., Ltd",
    "Organization Name": "Angkor Spring Co., Ltd",
    Type: "Mattress Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Horseware Products Cambodia Co., Ltd.",
    "Organization Name": "Horseware Products Cambodia Co., Ltd.",
    Type: "Horse Ware Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "O and M (Cambodia) Co., Ltd.",
    "Organization Name": "O and M (Cambodia) Co., Ltd.",
    Type: "Leather Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Person",
    Label: "Chan Chi Kwong",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "Chan Chi Kwong",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "Goldfame Enterprises (Int'l) Knitters Limited (Commercial Organization)",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": "Cambodian Chamber of Commerce (Government Organization)"
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Gold Dragon Printing & Carton Boxes Factory Co., Ltd",
    "Organization Name": "Gold Dragon Printing & Carton Boxes Factory Co., Ltd",
    Type: "Carton, Printing Plastic Label, Knitting",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "21, Paksun (SEZ), Setbou Commune, S'ang District, Kandal\\nprovince , Cambodia.\\n (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Daiwa Onkyo",
    "Organization Name": "Daiwa Onkyo",
    Type: "Speaker",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Cambodian Energy Limited",
    "Organization Name": "Cambodian Energy Limited",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 1 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Person",
    Label: "H.E. Oknha Ly Yong Phat",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "H.E. Oknha Ly Yong Phat",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "L.Y.P Group Co., Ltd. (Commercial Organization)",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Ji-Xiang Co., Ltd",
    "Organization Name": "Ji-Xiang Co., Ltd",
    Type: "Processing Cartons And Papers Production",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Wan Hai Hanger (Cambodia) Co., Ltd.",
    "Organization Name": "Wan Hai Hanger (Cambodia) Co., Ltd.",
    Type: "Founded Hnger",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Leegrow Plastic Packaging Co., Ltd.",
    "Organization Name": "Leegrow Plastic Packaging Co., Ltd.",
    Type: "Packaging Bag",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Doung Chhiv Phnom Den SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Kiri Vong District, Takeo Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "79 Ha|The ID Number (C4) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Doung Chhiv Phnom Den SEZ|Doung Chhiv Phnom Den SEZ",
    "ID Number": "C4",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Camko Motor Company Ltd",
    "Organization Name": "Camko Motor Company Ltd",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Neang Kok Koh Kong SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "DK Inc.",
    "Organization Name": "DK Inc.",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Neang Kok Koh Kong SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Neang Kok Village, Pakkhlong Commune, Mundul\\nseyma Destrict, Koh Kong Province",
    Source:
      "ABOUT KKSEZ – Koh Kong SEZ|SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839|https://kksez.com/about-us/",
    Notes:
      "335.43 Ha|Koh Kong SEZ industrial park is located on the western seaboard of Cambodia.|The ID Number (C6) is a unique ID number created for research purposes. It is not a true ID number.|The industrial estate is 330 kilometers from Laem Chabang port of Thailand, 285 kilometers from the port of Ha Tien in Vietnam, and 233 kilometers from Cambodia's main seaport Sihanoukville port.|the recent completion of National Road No.48 and the new expansion of road and highway to Thailand, make Koh Kong SEZ industrial estate an excellent location that provides convenient transportation.",
    "Location Name": "Koh Kong SEZ|Neang Kok Koh Kong SEZ|Neang Kok Koh Kong SEZ",
    "ID Number": "C6",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "Camko Motor Company Ltd (Commercial Organization)|Yazaki Corporation (Commercial Organization)",
    "Link: Appears In":
      "L.Y.P Group Co., Ltd. (Commercial Organization)|SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Ronchester",
    "Organization Name": "Ronchester",
    Type: "Lady's Apparel)",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Government Organization",
    Label: "Cambodian Chamber of Commerce",
    "Organization Name": "Cambodia Chamber of Commerce|Cambodian Chamber of Commerce",
    Type: "",
    "Located IVO": "",
    Source: "http://www.phnompenhpost.com/business/subedi-talks-rights-ccc-president-kith-meng",
    Notes: "Director: Kith Meng",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": "Chan Chi Kwong (Person)"
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Top Sports Textile Ltd.",
    "Organization Name": "Top Sports Textile Ltd.",
    Type: "Textile And Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Proceeding (Phnom Penh) Co., Ltd",
    "Organization Name": "Proceeding (Phnom Penh) Co., Ltd",
    Type: "Japanese Traditional Clothes",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "La More (Cambodia) Ltd.",
    "Organization Name": "La More (Cambodia) Ltd.",
    Type: "Footwear",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Clean Circle Co., Ltd",
    "Organization Name": "Clean Circle Co., Ltd",
    Type: "Leather Shoes",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Agricom (Cambodia) Co., Ltd",
    "Organization Name": "Agricom (Cambodia) Co., Ltd",
    Type: "Sugar Packaging",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Shandong Forest Wood (Cambodia) Co., Ltd",
    "Organization Name": "Shandong Forest Wood (Cambodia) Co., Ltd",
    Type: "Floor And Plywood",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Evergreen Industrial Co., Ltd",
    "Organization Name": "Evergreen Industrial Co., Ltd",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Manhattan International Corporation (MIC)",
    "Organization Name":
      "MANHATTAN INTERNATIONAL CO., LTD|Manhattan International Corporation (MIC)",
    Type: "",
    "Located IVO": "",
    Source:
      "Development History – Manhattan SEZ in Cambodia|https://www.manhattansez.com/%e5%95%86%e7%95%8c%e9%96%8b%e7%99%bc/",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "August 25, 2005",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "Development History – Manhattan SEZ in Cambodia.pdf (Document)|Manhattan SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Atlas Ice (Cambodia) Co., Ltd.",
    "Organization Name": "Atlas Ice (Cambodia) Co., Ltd.",
    Type: "Ice Manufacturing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Zhong Zheng (Cambodia) Co., Ltd.",
    "Organization Name": "Zhong Zheng (Cambodia) Co., Ltd.",
    Type: "Bags",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Nlc SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "The ID Number (C13) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Nlc SEZ",
    "ID Number": "C13",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Combi (Cambodia) Co., Ltd",
    "Organization Name": "Combi (Cambodia) Co., Ltd",
    Type: "Baby Goods And Toy",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Kaoway Sports Ltd.",
    "Organization Name": "Kaoway Sports Ltd.",
    Type: "Sport Shoes",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Premier Land Sihanoukville",
    "Organization Name": "Premier Land Sihanoukville",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "Ly Arporn (Person)|Seng Nhak (Person)",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "P (SEZ) I C",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Salatean And Preytob Villages, Chhrokmates Commune, Svayteab District, Svay Rieng Province.",
    Source: "",
    Notes: "107.55 Ha",
    "Location Name": "P (SEZ) I C",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Mds Thmorda SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Khum Thmorda, Srock Veal Veng, Pursat Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "2,265 Ha|The ID Number (C12) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Mds Thmorda SEZ|Mds Thmorda SEZ",
    "ID Number": "C12",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Cambox Private Limited",
    "Organization Name": "Cambox Private Limited",
    Type: "Plastic",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Liwayway (Cambodia) Food Industries Co., Ltd.",
    "Organization Name": "Liwayway (Cambodia) Food Industries Co., Ltd.",
    Type: "Food Processing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Wealth (Cambodia) Steel Industry Engineering Co., Ltd.",
    "Organization Name": "Wealth (Cambodia) Steel Industry Engineering Co., Ltd.",
    Type: "Steel Processing For Construction Material",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "MKK Co., Ltd",
    "Organization Name": "MKK Co., Ltd",
    Type: "Cigarette And Cigar",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Nakayama Shoji Co., Ltd.",
    "Organization Name": "Nakayama Shoji Co., Ltd.",
    Type: "Baby Underwear",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Sihanoukville Port SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Tomnop Rolok Area, Sangkat Lek1 And Lek3,\\nsihanoukville City, Preah Sihanouk Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "70 Ha|The ID Number (C17) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Sihanoukville Port SEZ|Sihanoukville Port SEZ",
    "ID Number": "C17",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Shin Feng Paper Co., Ltd.",
    "Organization Name": "Shin Feng Paper Co., Ltd.",
    Type: "Carton Box And Paper Processing)",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Suoy Chheng SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Neang Kok Village, Pakkhlong Commune, Mundul\\nseyma Destrict, Koh Kong Province",
    Source: "",
    Notes: "100Ha",
    "Location Name": "Suoy Chheng SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Phnom Penh SEZ Plc.",
    "Organization Name": "Phnom Penh SEZ Plc|Phnom Penh SEZ Plc.",
    Type: "",
    "Located IVO": "",
    Source:
      "Investor Relations PPSEZ|https://www.ppsez.com/en/investor-relation/business-overview?ref=ci",
    Notes:
      "Received the approval as a developer of a multi-product SEZ from the Royal Government of Cambodia on 19 April 2006|our company employs ninety-eight (98) personnel.",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "National Road No. 4, Sangkat Kantouk, Khan Posenchey In Phnom Penh, Cambodia",
    "Link: Investor in": "",
    "Link: Appears In": "Investor Relations PPSEZ.pdf (Document)|Phnom Penh SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "Poipet Pp SEZ (Location)",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Eastern Industrial Enterprise Inc.",
    "Organization Name": "Eastern Industrial Enterprise Inc.",
    Type: "Garment And Textile",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Kyowaseikan (Cambodia) Co., Ltd.",
    "Organization Name": "Kyowaseikan (Cambodia) Co., Ltd.",
    Type: "Packaging Materials",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Kingway Manufacturing Limited",
    "Organization Name": "Kingway Manufacturing Limited",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "21, Paksun (SEZ), Setbou Commune, S'ang District, Kandal\\nprovince , Cambodia.\\n (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Try Pheap Ou Ya Dav SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Located In Pak Thom Village, Pak Nhai Commune, Ou Ya Dav District, Ratanakiri Province",
    Source: "Try Pheap Group CO.,Ltd|http://trypheapgroup.com/en/?page=10",
    Notes: "approximately 136 hectares of land",
    "Location Name": "Ou Ya Dav SEZ|Try Pheap Ou Ya Dav SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)|Try Pheap Group Co., Ltd. (Commercial Organization)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Huang Jia Arts and Crafts Co., Ltd",
    "Organization Name": "Huang Jia Arts and Crafts Co., Ltd",
    Type: "Arts And Crafts Candle",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "N.L.C SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Phum Prey Phdao Abd Phum Thlok, Khum Chrok\\nmtes, Srok Svay Teab, Sray Rieng Province",
    Source: "",
    Notes: "105 Ha",
    "Location Name": "N.L.C SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Towa (Cambodia) Co., Ltd.",
    "Organization Name": "Towa (Cambodia) Co., Ltd.",
    Type: "Men's Suits",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Hongdou International Garment Co., Ltd",
    "Organization Name": "Hongdou International Garment Co., Ltd",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Sin Chn Hong (Cambodia) Plastics Industry Co., Ltd.",
    "Organization Name": "Sin Chn Hong (Cambodia) Plastics Industry Co., Ltd.",
    Type: "Plastic",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Oufeiya Leather (Cambodia) Co., Ltd.",
    "Organization Name": "Oufeiya Leather (Cambodia) Co., Ltd.",
    Type: "Leather Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Haru Phnom Penh Comic Center Co., Ltd",
    "Organization Name": "Haru Phnom Penh Comic Center Co., Ltd",
    Type: "Comic Book Assembly And Authoring",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Sihanoukville SEZ 2",
    "Organization Name": "",
    Type: "",
    "Located IVO":
      "Pou Thoung Village, Betrang Commune And\\nsmach Deang Village, Ream Commune, Prey Nop District, Preah Sihanouk Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "1,688 Ha|The ID Number (C16) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Sihanoukville SEZ 2|Sihanoukville SEZ 2",
    "ID Number": "C16",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "Aley Global (Cambodia) co., Ltd. (Commercial Organization)|Asle Electronic (Cambodia) Co., Ltd. (Commercial Organization)|BRILLIANT SHOES FACTORY Co., Ltd. (Commercial Organization)|Hongdou International Garment Co., Ltd (Commercial Organization)|Horseware Products Cambodia Co., Ltd. (Commercial Organization)|Huang Jia Arts and Crafts Co., Ltd (Commercial Organization)|Izumi (Cambodia) Co., Ltd. (Commercial Organization)|Keeptop Sporting Goods (Cambodia) Co., Ltd. (Commercial Organization)|Nanguo Garment co., ltd (Commercial Organization)|Oufeiya Leather (Cambodia) Co., Ltd. (Commercial Organization)|Prosource Electronics (Cambodia) Co., Ltd. (Commercial Organization)|Qianlima Vehicle Co., Ltd. (Commercial Organization)|Shandong Forest Wood (Cambodia) Co., Ltd (Commercial Organization)|Taihua Plastic Products Co., Ltd. (Commercial Organization)|Wan Hai Hanger (Cambodia) Co., Ltd. (Commercial Organization)|Wealth (Cambodia) Steel Industry Engineering Co., Ltd. (Commercial Organization)|Worldtec Cycles (Cambodia) Co., Ltd (Commercial Organization)|Zhong Zheng (Cambodia) Co., Ltd. (Commercial Organization)",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Galaxy Textile Co., Ltd",
    "Organization Name": "Galaxy Textile Co., Ltd",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Visca Plastics Joint Stock Company",
    "Organization Name": "Visca Plastics Joint Stock Company",
    Type: "Plastic",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Goldfame Star Enterprises (Cambodia) Limited",
    "Organization Name": "Goldfame Star Enterprises (Cambodia) Limited",
    Type: "Garment Manufacturer",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Person",
    Label: "Seng Nhak",
    "Organization Name": "",
    Type: "",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "Seng Nhak",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "Ly Arporn (Person)",
    "Link: Director Of": "Premier Land Sihanoukville (Commercial Organization)",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Tiger Wing Co., Ltd",
    "Organization Name": "Tiger Wing Co., Ltd",
    Type: "Footwear",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Swany (Cambodia) Corporation",
    "Organization Name": "Swany (Cambodia) Corporation",
    Type: "Gloves",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Navy Water Production Co., Ltd",
    "Organization Name": "Navy Water Production Co., Ltd",
    Type: "Drinking Water",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "BRILLIANT SHOES FACTORY Co., Ltd.",
    "Organization Name": "BRILLIANT SHOES FACTORY Co., Ltd.",
    Type: "Shoes",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "ARC Cambodia Corp.",
    "Organization Name": "ARC Cambodia Corp.",
    Type: "Hi-Tech Equipment Recycling",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Elite (Cambodia) Co., Ltd.",
    "Organization Name": "Elite (Cambodia) Co., Ltd.",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Civil (CP) Construction Product Ltd",
    "Organization Name": "Civil (CP) Construction Product Ltd",
    Type: "Pole",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Yorks (Cambodia) Co., Ltd.",
    "Organization Name": "Yorks (Cambodia) Co., Ltd.",
    Type: "Gloves",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Stung Hav SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Sangkat O Tres, Stung Hav District, Preah\\nsihanouk Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "196 Ha|The ID Number (C18) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Stung Hav SEZ|Stung Hav SEZ",
    "ID Number": "C18",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "D&m Bavet SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Bavet Commune, Chantrea District, Svay Rieng\\nprovince",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "117.95Ha|The ID Number (C41) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "D&m Bavet SEZ|D&m Bavet SEZ",
    "ID Number": "C41",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Keeptop Sporting Goods (Cambodia) Co., Ltd.",
    "Organization Name": "Keeptop Sporting Goods (Cambodia) Co., Ltd.",
    Type: "Bags Factory",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Pique Garment Co., Ltd",
    "Organization Name": "Pique Garment Co., Ltd",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Manhattan SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Yamaha Motor (Cambodia) Company Limited Co., Ltd",
    "Organization Name": "Yamaha Motor (Cambodia) Company Limited Co., Ltd",
    Type: "Motorcycle Assembly, Accessories And Spare Parts",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Tai Seng Bavet SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Bavet District, Svay Rieng Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "99 Ha|The ID Number (C14) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Tai Seng Bavet SEZ|Tai Seng Bavet SEZ",
    "ID Number": "C14",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "A and J (Cambodia) Co., Ltd. (Commercial Organization)|Atlantic Cycle Co., Ltd. (Commercial Organization)|DK Inc. (Commercial Organization)|Helsa South East Asia Co., Ltd. (Commercial Organization)|La More (Cambodia) Ltd. (Commercial Organization)|Nakayama Shoji Co., Ltd. (Commercial Organization)|Ronchester (Commercial Organization)|Smart Tech (Cambodia) Co., Ltd (Commercial Organization)|Swany (Cambodia) Corporation (Commercial Organization)|Towa (Cambodia) Co., Ltd. (Commercial Organization)|Yorks (Cambodia) Co., Ltd. (Commercial Organization)",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Oknha Mong SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Srea Ambel District, Koh Kong Province",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "100Ha|The ID Number (C7) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Oknha Mong SEZ|Oknha Mong SEZ",
    "ID Number": "C7",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Dishells (Cambodia) Ltd.",
    "Organization Name": "Dishells (Cambodia) Ltd.",
    Type: "Heat Insulation And Its Products",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "21, Paksun (SEZ), Setbou Commune, S'ang District, Kandal\\nprovince , Cambodia.\\n",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Sa Ang District, Kandal Province",
    Source: "",
    Notes: "80 Ha",
    "Location Name":
      "21, Paksun (SEZ), Setbou Commune, S'ang District, Kandal\\nprovince , Cambodia.\\n|Goldfame Pak Shun SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in":
      "Gold Dragon Printing & Carton Boxes Factory Co., Ltd (Commercial Organization)|Good Ray Development Limited (Commercial Organization)|Kingway Manufacturing Limited (Commercial Organization)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Qianlima Vehicle Co., Ltd.",
    "Organization Name": "Qianlima Vehicle Co., Ltd.",
    Type: "Vehicle Assembling",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "FST PP Co., Ltd.",
    "Organization Name": "FST PP Co., Ltd.",
    Type: "Japanese Traditional Clothes",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Sichuan New Hope Agribusiness (Cambodia) Co., Ltd.",
    "Organization Name": "Sichuan New Hope Agribusiness (Cambodia) Co., Ltd.",
    Type: "Animal Feed",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "Thary Kampong Cham SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Da Commune, Memot District, Kampong Cham\\nprovince",
    Source:
      "SEZ in Cambodia - CDC CIB CSEZB.pdf|https://data.opendevelopmentmekong.net/dataset/listofspecialeconomiczoneincambodia/resource/1ad318cf-da74-4b9e-a6ed-1016da925839",
    Notes:
      "142.14 Ha|The ID Number (C40) is a unique ID number created for research purposes. It is not a true ID number.",
    "Location Name": "Thary Kampong Cham SEZ|Thary Kampong Cham SEZ",
    "ID Number": "C40",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "SEZ in Cambodia - CDC CIB CSEZB.pdf (Document)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "A and J (Cambodia) Co., Ltd.",
    "Organization Name": "A and J (Cambodia) Co., Ltd.",
    Type: "Bicycle Manufacturing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Tai Seng Bavet SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Sunhsin Thread And String (Cambodia) Co., Ltd.",
    "Organization Name": "Sunhsin Thread And String (Cambodia) Co., Ltd.",
    Type: "Shoulder Pads",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Bok Seng PPSEZ Dry Port Co., Ltd",
    "Organization Name": "Bok Seng PPSEZ Dry Port Co., Ltd",
    Type: "Dry Port",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Asle Electronic (Cambodia) Co., Ltd.",
    "Organization Name": "Asle Electronic (Cambodia) Co., Ltd.",
    Type: "Electronics Parts",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Ajinomoto (Cambodia) Co., Ltd.",
    "Organization Name": "Ajinomoto (Cambodia) Co., Ltd.",
    Type: "Seasoning And Food Processing",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Location",
    Label: "S.N.C SEZ",
    "Organization Name": "",
    Type: "",
    "Located IVO": "Sangkat Bet Trang, Khan Prey Nob , Preah\\nsihanouk Province",
    Source: "",
    Notes: "150 Ha",
    "Location Name": "S.N.C SEZ",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Government Organization",
    Label: "Cambodia Investment Commission (CIB)",
    "Organization Name":
      "Cambodia Investment\\nCommission (CIB)|Cambodia Investment Commission (CIB)",
    Type: "",
    "Located IVO": "",
    Source:
      "Development History – Manhattan SEZ in Cambodia|https://www.manhattansez.com/%e5%95%86%e7%95%8c%e9%96%8b%e7%99%bc/",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "",
    "Link: Appears In":
      "Development History – Manhattan SEZ in Cambodia.pdf (Document)|Manhattan SEZ (Location)",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Zion Label And Printing Co., Ltd.",
    "Organization Name": "Zion Label And Printing Co., Ltd.",
    Type: "Labels",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Phnom Penh SEZ (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  },
  {
    "Object Type": "Commercial Organization",
    Label: "Nanguo Garment co., ltd",
    "Organization Name": "Nanguo Garment co., ltd",
    Type: "Garment",
    "Located IVO": "",
    Source: "",
    Notes: "",
    "Location Name": "",
    "ID Number": "",
    Role: "",
    Name: "",
    "Date of Registration": "",
    Address: "",
    "Link: Investor in": "Sihanoukville SEZ 2 (Location)",
    "Link: Appears In": "",
    "Link: President Of": "",
    "Link: Parent of": "",
    "Link: Manager of": "",
    "Link: Spouse of": "",
    "Link: Director Of": "",
    "Link: Owner of": "",
    "Link: Member of": ""
  }
]
export default CambodiaData
